import { render } from "./MailStatusDetailComponent.vue?vue&type=template&id=705de6d2&scoped=true"
import script from "./MailStatusDetailComponent.vue?vue&type=script&lang=js"
export * from "./MailStatusDetailComponent.vue?vue&type=script&lang=js"

import "./MailStatusDetailComponent.vue?vue&type=style&index=0&id=705de6d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705de6d2"]])

export default __exports__